import React from 'react';
import { Card, Descriptions, Space, Typography, Tag, Divider } from 'antd';
import {
  UserOutlined,
  MailOutlined,
  PhoneOutlined,
  EnvironmentOutlined,
  HomeOutlined,
  GlobalOutlined,
  CarOutlined
} from '@ant-design/icons';

const { Text } = Typography;

const CustomerInfo = ({ order }) => {
  const formatAddress = () => {
    if (!order.shipAddressLine1 && !order.shipCity && !order.shipCountryCode) {
      return 'No shipping address available';
    }

    const parts = [
      order.shipAddressLine1,
      order.shipAddressLine2,
      order.shipCity,
      order.shipStateOrRegion,
      order.shipPostalCode,
      order.shipCountryCode
    ].filter(Boolean);

    return parts.join(', ') || 'Address incomplete';
  };

  const getCountryFlag = (countryCode) => {
    const flags = {
      'US': '🇺🇸',
      'CA': '🇨🇦',
      'GB': '🇬🇧',
      'DE': '🇩🇪',
      'FR': '🇫🇷',
      'JP': '🇯🇵',
      'AU': '🇦🇺'
    };
    return flags[countryCode] || '🌍';
  };

  return (
    <Card 
      title={
        <Space>
          <UserOutlined />
          <span>Customer Information</span>
        </Space>
      } 
      style={{ marginBottom: 16 }} 
      className="customer-info-card"
    >
      <Descriptions column={1} size="small" colon={false}>
        <Descriptions.Item 
          label={
            <Space>
              <UserOutlined style={{ fontSize: '12px' }} />
              <span>Customer Name</span>
            </Space>
          }
        >
          <Text strong>{order.shipName || order.buyerName || 'N/A'}</Text>
        </Descriptions.Item>

        {order.buyerEmail && (
          <Descriptions.Item 
            label={
              <Space>
                <MailOutlined style={{ fontSize: '12px' }} />
                <span>Email</span>
              </Space>
            }
          >
            <Text copyable>{order.buyerEmail}</Text>
          </Descriptions.Item>
        )}

        {order.shipPhoneNumber && (
          <Descriptions.Item 
            label={
              <Space>
                <PhoneOutlined style={{ fontSize: '12px' }} />
                <span>Phone</span>
              </Space>
            }
          >
            <Text copyable>{order.shipPhoneNumber}</Text>
          </Descriptions.Item>
        )}

        <Divider style={{ margin: '12px 0' }} />

        <Descriptions.Item 
          label={
            <Space>
              <EnvironmentOutlined style={{ fontSize: '12px' }} />
              <span>Shipping Address</span>
            </Space>
          }
        >
          <div style={{ lineHeight: 1.6 }}>
            {order.shipAddressLine1 && (
              <div>
                <HomeOutlined style={{ marginRight: 6, fontSize: '12px', color: '#999' }} />
                <Text>{order.shipAddressLine1}</Text>
              </div>
            )}
            {order.shipAddressLine2 && (
              <div style={{ marginTop: 2 }}>
                <Text type="secondary">{order.shipAddressLine2}</Text>
              </div>
            )}
            {order.shipCity && (
              <div style={{ marginTop: 4 }}>
                <Text>
                  {order.shipCity}
                  {order.shipStateOrRegion && `, ${order.shipStateOrRegion}`}
                  {order.shipPostalCode && ` ${order.shipPostalCode}`}
                </Text>
              </div>
            )}
            {order.shipCountryCode && (
              <div style={{ marginTop: 4 }}>
                <Space>
                  <span>{getCountryFlag(order.shipCountryCode)}</span>
                  <Text strong>{order.shipCountryCode}</Text>
                </Space>
              </div>
            )}
          </div>
        </Descriptions.Item>

        <Divider style={{ margin: '12px 0' }} />

        {/* Delivery Instructions */}
        {order.deliveryInstructions && (
          <Descriptions.Item 
            label={
              <Space>
                <CarOutlined style={{ fontSize: '12px' }} />
                <span>Delivery Instructions</span>
              </Space>
            }
          >
            <Text italic style={{ color: '#666' }}>
              "{order.deliveryInstructions}"
            </Text>
          </Descriptions.Item>
        )}

        {/* Business Order Info */}
        {order.isBusinessOrder && (
          <Descriptions.Item label="Order Type">
            <Tag color="blue">Business Order</Tag>
          </Descriptions.Item>
        )}

        {/* Prime Status */}
        {order.isPrime && (
          <Descriptions.Item label="Prime Member">
            <Tag color="orange">Amazon Prime</Tag>
          </Descriptions.Item>
        )}

        {/* Replacement Order */}
        {order.isReplacementOrder && (
          <Descriptions.Item label="Order Type">
            <Tag color="purple">Replacement Order</Tag>
          </Descriptions.Item>
        )}
      </Descriptions>
    </Card>
  );
};

export default CustomerInfo; 